'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.State = undefined;

var _UserBox = require('@/components/UserBox');

var _UserBox2 = _interopRequireDefault(_UserBox);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _SidebarState = require('./SidebarState');

var _SidebarState2 = _interopRequireDefault(_SidebarState);

var _BufferSettings = require('./BufferSettings');

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

var _ChannelInfo = require('./ChannelInfo');

var _ChannelInfo2 = _interopRequireDefault(_ChannelInfo);

var _SidebarAboutBuffer = require('./SidebarAboutBuffer');

var _SidebarAboutBuffer2 = _interopRequireDefault(_SidebarAboutBuffer);

var _ChannelBanlist = require('./ChannelBanlist');

var _ChannelBanlist2 = _interopRequireDefault(_ChannelBanlist);

var _ChannelInvitelist = require('./ChannelInvitelist');

var _ChannelInvitelist2 = _interopRequireDefault(_ChannelInvitelist);

var _Nicklist = require('./Nicklist');

var _Nicklist2 = _interopRequireDefault(_Nicklist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.State = _SidebarState2.default;
exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        SidebarAboutBuffer: _SidebarAboutBuffer2.default,
        ChannelInfo: _ChannelInfo2.default,
        ChannelBanlist: _ChannelBanlist2.default,
        ChannelInvitelist: _ChannelInvitelist2.default,
        Nicklist: _Nicklist2.default,
        UserBox: _UserBox2.default
    },
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {
            pluginUiElements: _GlobalApi2.default.singleton().sideBarPlugins,
            accessTab: 'banlist'
        };
    },

    computed: {
        section: function section() {
            if (this.sidebarState.activeComponent) {
                return 'component';
            }

            return this.sidebarState.section() || 'nicklist';
        },

        settingShowJoinParts: {
            get: function get() {
                return this.buffer.setting('show_joinparts');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_joinparts', newVal);
            }
        },
        settingShowTopics: {
            get: function get() {
                return this.buffer.setting('show_topics');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_topics', newVal);
            }
        },
        settingShowNickChanges: {
            get: function get() {
                return this.buffer.setting('show_nick_changes');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_nick_changes', newVal);
            }
        },
        settingShowModeChanges: {
            get: function get() {
                return this.buffer.setting('show_mode_changes');
            },
            set: function set(newVal) {
                return this.buffer.setting('show_mode_changes', newVal);
            }
        },
        settingColouredNicklist: {
            get: function get() {
                return this.buffer.setting('coloured_nicklist');
            },
            set: function set(newVal) {
                return this.buffer.setting('coloured_nicklist', newVal);
            }
        },
        settingExtraFormatting: {
            get: function get() {
                return this.buffer.setting('extra_formatting');
            },
            set: function set(newVal) {
                return this.buffer.setting('extra_formatting', newVal);
            }
        },
        settingShareTyping: {
            get: function getSettingShareTyping() {
                return this.buffer.setting('share_typing');
            },
            set: function setSettingShareTyping(newVal) {
                return this.buffer.setting('share_typing', newVal);
            }
        },
        bufferType: function bufferType() {
            var type = '';

            if (!this.buffer) {
                type = 'none';
            } else if (this.buffer.isServer()) {
                type = 'server';
            } else if (this.buffer.isChannel()) {
                type = 'channel';
            } else if (this.buffer.isQuery()) {
                type = 'query';
            }

            return type;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Sidebar"]
window._kiwi_exports.components.Sidebar = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar.vue
// module id = f96R
// module chunks = 1